import StoreAdvancedForm from './StoreAdvancedForm'

export default StoreAdvancedForm
